(function ($) {$(function(){
    const modal = $('#director-info-modal');
    const directorWorks = $('#director-works');
    const director = $('.bio-btn');
    const body = $('body');
    const modalCloseBtn = $('#director-modal-close');
    director.on('click', function (e) {
        modal.addClass('active');
        body.addClass('director-info-modal-open');
        directorWorks.fadeOut(300)
    });
    modalCloseBtn.on('click', function (e) {
        modal.removeClass('active');
        body.removeClass('director-info-modal-open');
        directorWorks.fadeIn(300)
    });
});}(_jQ3));


// $html = wp_oembed_get($settings['vimeo_url']);
